import { ReactNode } from 'react';

import { ConfigGuard } from '@occc-app/App/guards';

type StoredValueGuardProps = {
  children: ReactNode;
  fallback?: ReactNode;
};

export const StoredValueGuard = ({ children, fallback }: StoredValueGuardProps) => {
  return (
    <ConfigGuard isFeatureEnabled={(config) => config.storedValue.enabled} fallback={fallback}>
      {children}
    </ConfigGuard>
  );
};
